// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"4093d3eb","359":"0e29942f","363":"bd11fe67","658":"9e6a55cd","966":"9a5c5252"}[chunkId] + ".chunk.js";
};